import { render, staticRenderFns } from "./AddAiBroadcast.vue?vue&type=template&id=9abe8c6e&"
import script from "./AddAiBroadcast.vue?vue&type=script&lang=js&"
export * from "./AddAiBroadcast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports